var _style, _g, _path, _path2, _circle, _circle2, _g2, _circle3, _circle4, _circle5, _g3, _circle6, _path3, _path4, _line, _line2, _path5, _line3, _line4, _line5, _line6, _line7, _path6, _path7, _path8, _path9, _path10, _path11, _line8, _line9, _line10, _line11, _line12, _line13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 366.4 112.8",
    style: {
      enableBackground: "new 0 0 366.4 112.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#164963;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:#EAEFF9;}\r\n\t.st2{fill:#90AED5;stroke:#0F324F;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:none;stroke:#0F324F;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st5{fill:#FFFFFF;stroke:#0F324F;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st6{fill:#EAEFF9;stroke:#164963;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st7{fill:#CCD9ED;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.9,97c0-9.2-7.1-16.8-16.1-17.5c-10.5-0.9-19.1,7.6-19.1,18.1v4.3c0,1.1-0.9,2-2,2l-149.9,0.2 c-1.1,0-2-0.9-2-2v-4.5c0-10.5-8.6-19-19.1-18.1c-9,0.8-16.1,8.3-16.1,17.5v5.1c0,1.1-0.9,2-2,2H54.4c-8.2,0-16.4-0.6-24.5-1.6 L2.5,98.8c-1-0.1-1.8-1-1.8-2V53l0.5-8.8L5.3,7.5c0.1-1,1-1.8,2-1.8h274.9c2.9,0,5.8,0.2,8.7,0.5l53.9,5.3c3.3,0.3,6,2.6,6.9,5.8 l11.5,39.9c1.5,5.3,2.3,10.8,2.3,16.4v22.4c0,4.5-3.7,8.2-8.2,8.2h-54.5c-1.1,0-2-0.9-2-2L300.9,97L300.9,97z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.6,91.1H0.8V77h364.9v14.1h-65.7c-2.3-6.4-8.1-11-15.1-11.6c-8.2-0.7-15.2,4.3-17.9,11.6H110.6 c-2.7-7.3-9.8-12.3-17.9-11.6C85.7,80.1,79.9,84.7,77.6,91.1C77.6,91.1,77.6,91.1,77.6,91.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 94.2,
    cy: 97,
    r: 15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 94.2,
    cy: 97,
    r: 9.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.8,101.4c1.6,3,4.7,5.1,8.3,5.1s6.8-2.1,8.3-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M102.5,92.7c-1.6-3-4.7-5.1-8.3-5.1s-6.7,2-8.3,4.9"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 94.2,
    cy: 97,
    r: 5.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 283.3,
    cy: 97,
    r: 15
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 283.3,
    cy: 97,
    r: 9.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M275,101.4c1.6,3,4.7,5.1,8.3,5.1s6.8-2.1,8.3-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M291.6,92.7c-1.6-3-4.7-5.1-8.3-5.1s-6.7,2-8.3,4.9"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 283.3,
    cy: 97,
    r: 5.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M75.7,0.8h185.1c2.7,0,4.9,2.2,4.9,4.9H70.8C70.8,2.9,73,0.8,75.7,0.8L75.7,0.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M300.9,97c0-9.2-7.1-16.8-16.1-17.5c-10.5-0.9-19.1,7.6-19.1,18.1v4.3c0,1.1-0.9,2-2,2l-149.9,0.2 c-1.1,0-2-0.9-2-2v-4.5c0-10.5-8.6-19-19.1-18.1c-9,0.8-16.1,8.3-16.1,17.5v5.1c0,1.1-0.9,2-2,2H54.4c-8.2,0-16.4-0.6-24.5-1.6 L2.5,98.8c-1-0.1-1.8-1-1.8-2V53l0.5-8.8L5.3,7.5c0.1-1,1-1.8,2-1.8h274.9c2.9,0,5.8,0.2,8.7,0.5l53.9,5.3c3.3,0.3,6,2.6,6.9,5.8 l11.5,39.9c1.5,5.3,2.3,10.8,2.3,16.4v22.4c0,4.5-3.7,8.2-8.2,8.2h-54.5c-1.1,0-2-0.9-2-2L300.9,97L300.9,97z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 5.3,
    y1: 66.8,
    x2: 148.7,
    y2: 66.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 176.3,
    y1: 66.8,
    x2: 323.9,
    y2: 66.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327.4,48.3V13.9l14.3,1.1c3.3,0.3,6.2,2.6,7.1,5.8l10.8,37.3c0.4,1.3-0.6,2.6-2,2.6h-30.2L327.4,48.3 L327.4,48.3z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 40.8,
    y1: 91.1,
    x2: 77.6,
    y2: 91.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 110.6,
    y1: 91.1,
    x2: 147.4,
    y2: 91.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 176.3,
    y1: 91.1,
    x2: 266.9,
    y2: 91.1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 299.7,
    y1: 91.1,
    x2: 323.9,
    y2: 91.1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 327.4,
    y1: 101.4,
    x2: 327.4,
    y2: 66.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.9,30.5h14c0.9,0,1.6,0.6,1.9,1.4l7.1,22.7c0.1,0.2,0.1,0.4,0.1,0.6v2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M5.3,46.2L9.4,9.5h274c2.9,0,5.8,0.1,8.6,0.5l31.8,3.4v34.8H5.3V46.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M7.7,24.9L9.4,9.5h274.1c2.9,0,5.8,0.1,8.6,0.5l31.8,3.4v11.5H7.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327.4,24.9v-11l14.3,1.1c3.3,0.3,6.2,2.6,7.1,5.8l1.2,4.1H327.4L327.4,24.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M327.4,48.3V13.9l14.3,1.1c3.3,0.3,6.2,2.6,7.1,5.8l10.8,37.3c0.4,1.3-0.6,2.6-2,2.6h-30.2L327.4,48.3 L327.4,48.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.3,46.2L9.4,9.5h274c2.9,0,5.8,0.1,8.6,0.5l31.8,3.4v34.8H5.3V46.2z"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 330.9,
    y1: 66.8,
    x2: 337.6,
    y2: 66.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 358.8,
    y1: 66.8,
    x2: 365.2,
    y2: 66.8
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 358.8,
    y1: 91.1,
    x2: 365.6,
    y2: 91.1
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 358.8,
    y1: 94.7,
    x2: 365.6,
    y2: 94.7
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1.9,
    y1: 91.1,
    x2: 35.8,
    y2: 91.1
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1.9,
    y1: 94.7,
    x2: 35.8,
    y2: 94.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach);
export default __webpack_public_path__ + "static/media/coach.5eb3444d08cbda8fa020ff28552418d2.svg";
export { ForwardRef as ReactComponent };